<template>
    <v-app-bar color="white" clipped-right flat min-height="150" class="global-header">
        <v-container>
            <v-row>
                <v-col sm="1" md="3" cols="12" order="1" class="left">
                    <v-btn icon large @click="$emit('drawerClicked')">
                        <img style="width:40px; height:28px;" src="@/assets/icons/burger.svg" />
                    </v-btn>
                </v-col>
                <v-col sm="8" md="6" cols="12" order="2" class="center">
                    <v-toolbar-title>
                        <h1>
                            <a :href="logoLink" title="Ashburton District Council Website">
                                Ashburton District Council
                            </a>
                        </h1>
                    </v-toolbar-title>
                </v-col>
                <v-col sm="3" cols="12" order="3" class="right">
                    <v-toolbar-items class="float-right">
                        <router-link class="v-toolbar__items-onboard v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--large" :to="{path: getOnBoardLink.href}">
                            <span class="v-btn__content">
                                {{ getOnBoardLink.name }}
                            </span>
                        </router-link>
                        <!-- <v-btn outlined large min-height="50" :href="getOnBoardLink.href" :target="getOnBoardLink.target" class="v-toolbar__items-onboard">Get on board</v-btn> -->
                    </v-toolbar-items>
                </v-col>
                <!-- <v-col v-if="$store.state.hasMounted" cols="6" class="align-center d-flex justify-space-around justify-sm-end">
                    <a :href="socialData.facebookURL" v-if="socialData.facebookEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/fb.svg" alt="Facebook link" />
                    </a>
                    <a :href="socialData.instagramURL" v-if="socialData.instagramEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/in.svg" alt="Instagram link" />
                    </a>
                    <a :href="socialData.twitterURL" v-if="socialData.twitterEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/twitter.svg" alt="Twitter link" />
                    </a>
                    <a :href="socialData.youtubeURL" v-if="socialData.youtubeEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/Youtube.svg" alt="Youtube link" />
                    </a>
                    <a :href="socialData.linkedinURL" v-if="socialData.linkedinEnable" target="_blank">
                        <img class="mr-sm-6" src="@/assets/icons/Linkedin.svg" alt="LinkedIn link" />
                    </a>
                </v-col> -->
            </v-row>
            <!-- <v-app-bar-nav-icon @click="$emit('drawerClicked')" color="white"></v-app-bar-nav-icon> -->
        </v-container>
    </v-app-bar>
</template>

<script>
  export default {
    props: ['menu'],
    computed: {
        // socialData() {
        //     return this.$store.getters.getSocialSettings
        // },
        logo() {
            return this.$store.getters.getLogo
        },
        logoLink() {
            return this.$store.getters.getLogoLink
        },
        getOnBoard() {
            return this.$store.getters.getOnBoard
        },
        getOnBoardLink() {
            let item = this.menu.filter((el) => {
                if(el.name === 'Get On Board') {
                    return el
                }
            })
            return item[0]
        }
    }
  }
</script>

<style lang="scss">
    .v-toolbar__content {
        height: auto!important;
        //max-height: 150px;
        padding: 0 !important;
    }
    .v-application {
        .v-toolbar {
            flex: 0 0 auto!important;
            height: auto!important;

            @media all and (max-width: 670px) {
                //min-height: 240px !important;

                .left {
                    width: 50%;
                    order: 2 !important;
                    max-width: 100%;
                }

                .center {
                    width: 100%;
                    order: 1 !important;
                    max-width: 100%;

                    display: none;
                }

                .right {
                    width: 50%;
                    order: 3 !important;
                    max-width: 100%;
                }
            }

            .logo {
                // width: 250px;
                // height: 85px;
                max-width: 100%;

                @media (min-width: 600px) {
                    max-width: 213px;
                }
            }

            &__content {
                height: auto!important;

                .container {
                    padding: 0 12px;
                    min-height: 89px;
                }

                .v-btn { 
                    vertical-align: middle;
                    align-self: center;
                    margin-top: 8px;
                }
            }

            .v-toolbar__title { 
                text-align: center;

                a {
                    text-decoration: none;
                    font-size: 18px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    font-weight: 600;
                    vertical-align: middle;
                }
            }
            
            .v-toolbar__items {
                align-items: center;

                a.v-toolbar__items-onboard {
                    border: 2px solid #ccc;
                    padding: 14px 26px;
                    border-radius: 10px;
                    font-size: 16px;
                    font-weight: 600;
                    text-transform: initial;
                    color: var(--v-anchor-base);
                    line-height: normal;
                    margin-top: 6px;
                }

            }
        }

        header.global-header {
            background: url('../assets/header-gradient-squares.svg');
            background-position: bottom;
            background-size: auto;
            background-repeat: repeat-x;

            .container {
                @media (min-width: 992px) and (max-width:1903px) {
                    max-width: 1250px;
                }
            }
        }
    }


</style>